export const translations = {
  fi: {
    nav: {
      home: "Etusivu",
      about: "Meistä",
      menu: "Ruokalista",
      contact: "Yhteystiedot",
      book: "Varaa pöytä",
      order: "Tilaa verkosta"
    },
    hero: {
      title: "Tervetuloa Buffalo Grill Houseen",
      subtitle: "Aitoja makuja, grilliherkkuja ja viihtyisä tunnelma Klaukkalassa.",
      cta_order: "Tilaa verkosta",
      cta_book: "Varaa pöytä"
    },
    about: {
      title: "Tarinamme",
      content: "Buffalo Grill House on uusi, energinen ravintola Klaukkalan sydämessä. Intohimonamme on tarjota aitoja ja rehellisiä makuja: mehevät pihvit, kiviuunipizzat, aidot turkkilaiset grillit ja maukkaat kebabit valmistuvat käsissämme suurella sydämellä. Haluamme olla paikka, johon on helppo tulla viihtymään perheen ja ystävien kanssa hyvän ruoan äärelle."
    },
    menu: {
      title: "Ruokalistamme",
      subtitle: "Tutustu laajaan valikoimaamme",
      categories: {
        pizzas: "Pizzat",
        own_choice_pizza: "Own Choice Pizza",
        new_pizzas: "New Pizzas",
        kebabs: "Kebabit",
        chicken_kebabs: "Kanakebabit",
        falafels: "Falafelit",
        salads: "Salaatit",
        grills: "Grillit",
        schnitzels: "Leikkeet",
        kids: "Lapsille",
        vege_burgers: "Vege Burgerit",
        burgers: "Burgerit",
        desserts: "Jälkiruoat"
      },
      download_pdf: "Lataa ruokalista (PDF)"
    },
    reservation: {
      title: "Varaa pöytä",
      subtitle: "Tule nauttimaan paikan päälle",
      form: {
        date: "Päivämäärä",
        time: "Aika",
        guests: "Henkilömäärä",
        name: "Nimi",
        phone: "Puhelinnumero",
        email: "Sähköposti",
        submit: "Vahvista varaus",
        success_title: "Kiitos varauksesta!",
        success_message: "Otamme sinuun yhteyttä vahvistaaksemme varauksen sähköpostitse."
      }
    },
    contact: {
      title: "Yhteystiedot",
      address: "Osoite",
      phone: "Puhelin",
      hours: "Aukioloajat",
      hours_mon_thu: "Ma-To 10.30-21.00",
      hours_fri: "Pe 10.30-22.00",
      hours_sat: "La 11.00-22.00",
      hours_sun: "Su 11.00-21.00"
    },
    footer: {
      rights: "Kaikki oikeudet pidätetään.",
      privacy: {
        link: "Tietosuoja & Evästeet",
        title: "Tietosuojaseloste ja Evästekäytäntö",
        content: `TIETOSUOJASELOSTE JA EVÄSTEKÄYTÄNTÖ
        
        Viimeksi päivitetty: 04.02.2025

        1. REKISTERINPITÄJÄ
        Buffalo Grill House
        Kuonomäentie 1, 01800 Nurmijärvi
        Puh: 09 8797826

        2. HENKILÖTIETOJEN KÄSITTELYN TARKOITUS JA PERUSTE
        Keräämme henkilötietoja asiakassuhteen hoitamiseksi, pöytävarausten käsittelemiseksi ja palveluidemme kehittämiseksi. Tietojen käsittely perustuu asiakkaan suostumukseen tai sopimuksen täytäntöönpanoon (esim. pöytävaraus).

        3. KERÄTTÄVÄT TIEDOT
        Voimme kerätä seuraavia tietoja:
        - Nimi ja yhteystiedot (puhelinnumero, sähköposti)
        - Varaustiedot (päivämäärä, aika, henkilömäärä)
        - Muut asiakkaan vapaaehtoisesti antamat tiedot

        4. TIETOJEN LUOVUTUS
        Emme myy, vaihda tai vuokraa henkilötietojasi kolmansille osapuolille. Tietoja voidaan luovuttaa viranomaisille vain lain edellyttämissä tapauksissa.

        5. EVÄSTEET (COOKIES)
        Käytämme sivustollamme evästeitä parantaaksemme käyttökokemusta.
        - Välttämättömät evästeet: Nämä ovat pakollisia sivuston toiminnalle (esim. kielivalinta).
        - Suorituskykyevästeet: Auttavat meitä ymmärtämään, miten sivustoa käytetään.

        Jatkamalla sivuston käyttöä hyväksyt evästeiden käytön.

        6. REKISTERÖIDYN OIKEUDET
        Sinulla on oikeus tarkastaa itseäsi koskevat tiedot, vaatia virheellisen tiedon oikaisua tai tietojen poistamista. Ota yhteyttä ravintolaan näissä asioissa.`
      },
      consent: {
        text: "Käytämme evästeitä parantaaksemme käyttökokemustasi. Jatkamalla sivuston käyttöä hyväksyt evästeiden käytön ja tietosuojakäytäntömme.",
        accept: "Hyväksyn",
        read_more: "Lue lisää"
      }
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      menu: "Menu",
      contact: "Contact",
      book: "Book a Table",
      order: "Order Online"
    },
    hero: {
      title: "Welcome to Buffalo Grill House",
      subtitle: "Authentic flavors, grilled delicacies, and a cozy atmosphere in Klaukkala.",
      cta_order: "Order Online",
      cta_book: "Book a Table"
    },
    about: {
      title: "Our Story",
      content: "Buffalo Grill House is a new, energetic restaurant in the heart of Klaukkala. Our passion is to serve authentic and honest flavors: juicy steaks, stone oven pizzas, authentic Turkish grills, and tasty kebabs are prepared with a big heart. We want to be a place where it's easy to come and enjoy good food with family and friends."
    },
    menu: {
      title: "Our Menu",
      subtitle: "Explore our wide selection",
      categories: {
        pizzas: "Pizzas",
        own_choice_pizza: "Own Choice Pizza",
        new_pizzas: "New Pizzas",
        kebabs: "Kebabs",
        chicken_kebabs: "Chicken Kebabs",
        falafels: "Falafels",
        salads: "Salads",
        grills: "Grills",
        schnitzels: "Schnitzels",
        kids: "For Kids",
        vege_burgers: "Vege Burgers",
        burgers: "Burgers",
        desserts: "Desserts"
      },
      download_pdf: "Download Menu (PDF)"
    },
    reservation: {
      title: "Book a Table",
      subtitle: "Come enjoy with us",
      form: {
        date: "Date",
        time: "Time",
        guests: "Number of Guests",
        name: "Name",
        phone: "Phone Number",
        email: "Email",
        submit: "Confirm Reservation",
        success_title: "Thank you for booking!",
        success_message: "We will contact you via email to confirm your reservation."
      }
    },
    contact: {
      title: "Contact Us",
      address: "Address",
      phone: "Phone",
      hours: "Opening Hours",
      hours_mon_thu: "Mon-Thu 10.30-21.00",
      hours_fri: "Fri 10.30-22.00",
      hours_sat: "Sat 11.00-22.00",
      hours_sun: "Sun 11.00-21.00"
    },
    footer: {
      rights: "All rights reserved.",
      privacy: {
        link: "Privacy Policy & Cookies",
        title: "Privacy Policy and Cookie Usage",
        content: `PRIVACY POLICY AND COOKIE USAGE
        
        Last Updated: 04.02.2025

        1. DATA CONTROLLER
        Buffalo Grill House
        Kuonomäentie 1, 01800 Nurmijärvi
        Phone: 09 8797826

        2. PURPOSE AND BASIS OF DATA PROCESSING
        We collect personal data to manage customer relationships, process table reservations, and improve our services. Processing is based on customer consent or the execution of a contract (e.g., table reservation).

        3. COLLECTED DATA
        We may collect the following information:
        - Name and contact details (phone number, email)
        - Reservation details (date, time, number of guests)
        - Other information voluntarily provided by the customer

        4. DATA DISCLOSURE
        We do not sell, trade, or rent your personal data to third parties. Data may only be disclosed to authorities when required by law.

        5. COOKIES
        We use cookies on our site to improve user experience.
        - Essential Cookies: Mandatory for site functionality (e.g., language selection).
        - Performance Cookies: Help us understand how the site is used.

        By continuing to use the site, you accept the use of cookies.

        6. DATA SUBJECT RIGHTS
        You have the right to inspect your data, request correction of incorrect data, or request deletion. Please contact the restaurant regarding these matters.`
      },
      consent: {
        text: "We use cookies to improve your experience. By continuing to visit this site you agree to our use of cookies and privacy policy.",
        accept: "I Accept",
        read_more: "Read More"
      }
    }
  },
  sv: {
    nav: {
      home: "Hem",
      about: "Om Oss",
      menu: "Meny",
      contact: "Kontakt",
      book: "Boka Bord",
      order: "Beställ Online"
    },
    hero: {
      title: "Välkommen till Buffalo Grill House",
      subtitle: "Autentiska smaker, grilldelikatesser och en mysig atmosfär i Klaukkala.",
      cta_order: "Beställ Online",
      cta_book: "Boka Bord"
    },
    about: {
      title: "Vår Historia",
      content: "Buffalo Grill House är en ny, energisk restaurang i hjärtat av Klaukkala. Vår passion är att servera autentiska och ärliga smaker: saftiga biffar, stenugnspizzor, autentiska turkiska grillar och smakrika kebaber tillagas med stort hjärta. Vi vill vara en plats där det är lätt att komma och njuta av god mat med familj och vänner."
    },
    menu: {
      title: "Vår Meny",
      subtitle: "Utforska vårt breda urval",
      categories: {
        pizzas: "Pizzor",
        own_choice_pizza: "Own Choice Pizza",
        new_pizzas: "New Pizzas",
        kebabs: "Kebab",
        chicken_kebabs: "Kycklingkebab",
        falafels: "Falafel",
        salads: "Sallader",
        grills: "Grillrätter",
        schnitzels: "Schnitzels",
        kids: "För Barn",
        vege_burgers: "Vege Burgare",
        burgers: "Burgare",
        desserts: "Efterrätter"
      },
      download_pdf: "Ladda ner meny (PDF)"
    },
    reservation: {
      title: "Boka Bord",
      subtitle: "Kom och njut hos oss",
      form: {
        date: "Datum",
        time: "Tid",
        guests: "Antal Personer",
        name: "Namn",
        phone: "Telefonnummer",
        email: "E-post",
        submit: "Bekräfta Bokning",
        success_title: "Tack för din bokning!",
        success_message: "Vi kommer att kontakta dig via e-post för att bekräfta din bokning."
      }
    },
    contact: {
      title: "Kontakta Oss",
      address: "Adress",
      phone: "Telefon",
      hours: "Öppettider",
      hours_mon_thu: "Mån-Tor 10.30-21.00",
      hours_fri: "Fre 10.30-22.00",
      hours_sat: "Lör 11.00-22.00",
      hours_sun: "Sön 11.00-21.00"
    },
    footer: {
      rights: "Alla rättigheter förbehållna.",
      privacy: {
        link: "Integritetspolicy & Cookies",
        title: "Integritetspolicy och Cookie-användning",
        content: `INTEGRITETSPOLICY OCH COOKIE-ANVÄNDNING
        
        Senast uppdaterad: 04.02.2025

        1. PERSONUPPGIFTSANSVARIG
        Buffalo Grill House
        Kuonomäentie 1, 01800 Nurmijärvi
        Tel: 09 8797826

        2. SYFTE OCH GRUND FÖR DATABEHANDLING
        Vi samlar in personuppgifter för att hantera kundrelationer, behandla bordsbokningar och förbättra våra tjänster. Behandlingen grundar sig på kundens samtycke eller fullgörande av avtal (t.ex. bordsbokning).

        3. INSAMLAD DATA
        Vi kan samla in följande information:
        - Namn och kontaktuppgifter (telefonnummer, e-post)
        - Bokningsuppgifter (datum, tid, antal personer)
        - Annan information som kunden frivilligt lämnar

        4. DATAUTLÄMNING
        Vi säljer, byter eller hyr inte ut dina personuppgifter till tredje part. Data får endast lämnas ut till myndigheter när lagen kräver det.

        5. COOKIES
        Vi använder cookies på vår webbplats för att förbättra användarupplevelsen.
        - Nödvändiga Cookies: Obligatoriska för webbplatsens funktionalitet (t.ex. språkval).
        - Prestandacookies: Hjälper oss förstå hur webbplatsen används.

        Genom att fortsätta använda webbplatsen godkänner du användningen av cookies.

        6. RÄTTIGHETER
        Du har rätt att inspektera dina uppgifter, begära rättelse av felaktiga uppgifter eller begära radering. Kontakta restaurangen angående dessa frågor.`
      },
      consent: {
        text: "Vi använder cookies för att förbättra din upplevelse. Genom att fortsätta besöka denna webbplats godkänner du vår användning av cookies och integritetspolicy.",
        accept: "Jag Accepterar",
        read_more: "Läs Mer"
      }
    }
  }
};
